import React, { useState } from 'react';

import Uuid from '../../../../../support/Uuid';
import CuentaPredialForm from './CuentaPredialForm';
import CuentaPredialList from './CuentaPredialList';

const CuentaPredialManager = (props) => {
  const [editing, setEditing] = useState(null);

  const handleOnAdd = (data) => {
    const { CuentaPredial = [] } = props.data;

    const newData = CuentaPredial.concat([
      {
        id: Uuid.v4(),
        ...data,
      },
    ]);

    setEditing(null);

    handleOnListChange(newData);
  };

  const handleOnEdit = (item) => {
    setEditing(item);

    const { CuentaPredial = {} } = props.data;

    const newData = CuentaPredial.filter((value) => value.id !== item.id);

    handleOnListChange(newData);
  };

  const handleOnListChange = (data) => {
    props.onFormDataChange(
      {
        ...props.data,
        CuentaPredial: data,
      },
      { isValid: true, name: 'isValidCuentaPredial' }
    );
  };

  const { CuentaPredial = [] } = props.data;

  return (
    <div className="pb-4">
      <div>
        <strong className="text-black text-upper">Cuenta predial</strong>
      </div>

      <div className="pt-2">
        <CuentaPredialForm
          editing={editing}
          onAdd={handleOnAdd}
        />
      </div>

      <div className="pt-2">
        <CuentaPredialList
          editing={editing}
          data={CuentaPredial}
          onEdit={handleOnEdit}
          onChange={handleOnListChange}
        />
      </div>
    </div>
  );
};

export default CuentaPredialManager;
